import axios from "axios";
import * as Constants from "../../constant";
const URL = Constants?.LOCAL_URL;

export const inviteOTP = async (OTP) => {
	try {
		const res = await axios.get(`${URL}/invite/${OTP}`);
		return {
			type: "User_OTP",
			payload: res.data,
		};
	} catch (error) {
		return {
			type: "User_OTP",
			payload: error,
		};
	}
};
export const otpForgetPassword = async (OTP) => {
	try {
		const res = await axios.get(`${URL}/password-reset/${OTP}`);
		return {
			type: "User_OTP",
			payload: res.data,
		};
	} catch (error) {
		return {
			type: "User_OTP",
			payload: error,
		};
	}
};

export const forgotPassword = async (fPass) => {
	try {
		const res = await axios.post(`${URL}/password-reset`, fPass);
		return {
			type: "User_OTP",
			payload: res.data,
		};
	} catch (error) {
		return {
			type: "User_OTP",
			payload: error,
		};
	}
};
